<template>
  <div class="experience">
    <div class="experience-tabs">
      <div class="tabs-box flex-align-center width-1200">
        <div
          class="tab-item margin-r-4 margin-l-20"
          :class="activeKey == 'textTranslate' && 'tab-item-active'"
          @click="changeTabs('textTranslate')"
        >
          文本翻译
        </div>
        <div
          class="tab-item margin-r-4"
          :class="activeKey == 'docTranslate' && 'tab-item-active'"
          @click="changeTabs('docTranslate')"
        >
          文档翻译
        </div>
        <div
          v-if="settingDetail?.enable_image_translation === 'true'"
          class="tab-item"
          :class="activeKey == 'imgTranslate' && 'tab-item-active'"
          @click="changeTabs('imgTranslate')"
        >
          图片翻译
        </div>
        <div class="translate-btn-box">
          <div
            class="translate-btn flex-center"
            v-show="userInfo && userInfo.casId"
            @click="visible = true"
          >
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-shezhi"></use>
            </svg>
            <span>翻译设置</span>
          </div>
        </div>
      </div>
      <!-- 文本翻译 -->
      <div class="width-1200" v-if="activeKey == 'textTranslate'">
        <text-translation :translateMode="translateMode"></text-translation>
      </div>
      <!-- 文档翻译 -->
      <div class="width-1200" v-if="activeKey == 'docTranslate'">
        <doc-tab ref="docRef"></doc-tab>
      </div>
      <!-- 图片翻译 -->
      <div class="width-1200" v-if="activeKey == 'imgTranslate'">
        <img-tab></img-tab>
      </div>
    </div>
    <a-modal
      title="翻译设置"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      centered
    >
      <div>
        <div class="margin-b-20">
          <div>
            <a-checkbox v-model:checked="autoPay">译力自动支付</a-checkbox>
          </div>
          <div class="color-999 padding-l-24">若账户译力充足，则自动支付</div>
        </div>
        <div>
          <div>
            <a-checkbox v-model:checked="translateMode">实时翻译</a-checkbox>
          </div>
          <div class="color-999 padding-l-24">
            根据翻译内容自动推荐引擎，无需二次确认
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { ref, onMounted, reactive, toRefs, computed, onUnmounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { message } from 'ant-design-vue'

  import DocTab from './docTranslation/index.vue'
  import ImgTab from './imgTranslation/index.vue'
  import textTranslation from './textTranslation/index.vue'
  import {
    checkDocMtAuthority,
    getUserGetDict,
    setUserGetDict,
  } from '@/http/api'
  import { useStore } from 'vuex'

  export default {
    components: {
      ImgTab,
      DocTab,
      textTranslation,
    },
    setup() {
      const router = useRouter()
      const route = useRoute()
      const query = route.query
      const userInfo = computed(() => store.state.user.userInfo)
      const settingDetail = computed(() => store.state.comm.settingDetail)
      const docRef = ref(null)
      // 初始化state
      const state = reactive({
        activeKey: query?.activeKey || 'textTranslate',
        visible: false,
      })

      const translateMode = computed({
        set(val) {
          store.commit('user/changeKey', {
            translateMode: val,
          })
        },
        get() {
          return store.state.user.translateMode
        },
      })

      const autoPay = computed({
        set(val) {
          store.commit('user/changeKey', {
            autoPay: val,
          })
        },
        get() {
          return store.state.user.autoPay
        },
      })

      const store = useStore()

      const permission = computed(
        () => store.state.comm.enterpriseGlobalObj?.permission || []
      )

      const initValue = async () => {
        await getUserGetDict({ key: 'automatic-payment' }).then((res) => {
          if (res.data.value) {
            autoPay.value = JSON.parse(res.data.value) ? true : false
          } else {
            autoPay.value = false
          }
        })
        await getUserGetDict({ key: 'real-time-translation' }).then((res) => {
          if (res.data.value) {
            translateMode.value = JSON.parse(res.data.value) ? true : false
          } else {
            translateMode.value = false
          }
        })
      }
      const handleCancel = () => {
        initValue()
        state.visible = false
      }
      const handleOk = () => {
        setUserGetDict({
          key: 'automatic-payment',
          value: `${autoPay.value}`,
        })
        setUserGetDict({
          key: 'real-time-translation',
          value: `${translateMode.value}`,
        })
        state.visible = false
      }
      // 切换面板
      const changeTabs = (key) => {
        function goTo() {
          state.activeKey = key
          let query = { ...route.query }
          //如果路由带type 则说明是由重新机翻文档进来的，无需切换路由;
          if (!query.type) {
            query.activeKey = key
            router.replace({
              query,
            })
          }
        }
        if (docRef?.value) {
          docRef?.value?.init(
            () => {
              goTo()
            },
            () => {
              goTo()
            }
          )
        } else {
          goTo()
        }
      }
      // 监听复制事件
      const copyHandler = () => {
        document.addEventListener(
          'copy ',
          function (e) {
            e.preventDefault()
          },
          false
        )
      }

      function pasteHandlerFunc(e) {
        e.preventDefault()
        let text = e.clipboardData.getData('text/plain')
        text = text.replace(/</g, '&lt;')
        text = text.replace(/\/>/g, '&gt;')
        document.execCommand('insertHTML', false, text)
      }

      onMounted(() => {
        if (
          userInfo.value &&
          userInfo.value.casId &&
          route.query.enterpriseId
        ) {
          initValue()
        }
        copyHandler()
        document.addEventListener('paste', pasteHandlerFunc)

        if (route.query.type) {
          state.activeKey = route.query.type
        }
      })

      onUnmounted(() => {
        document.removeEventListener('paste', pasteHandlerFunc)
      })
      return {
        userInfo,
        autoPay,
        translateMode,
        handleCancel,
        handleOk,
        router,
        ...toRefs(state),
        changeTabs,
        docRef,
        settingDetail,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .experience {
    background: #fafafc;
    min-height: calc(100vh - 126px);
    .tabs-box {
      position: relative;
      padding-top: 20px;
      .tab-item {
        width: 114px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        color: #666;
        background: #f2f3f5;
        border-radius: 8px 8px 0px 0px;
        cursor: pointer;
        &:hover {
          font-weight: 600;
        }
      }
      .tab-item-active {
        color: #fff;
        background: var(--primary-color);
        font-weight: 600;
      }
    }
  }
  .translate-btn-box {
    position: absolute;
    top: 22px;
    right: 0;
    width: 300px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .translate-btn {
      width: 100px;
      height: 32px;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        background: #f2f3f5;
      }
      svg {
        width: 16px;
        height: 16px;
      }
      span {
        color: #666;
        font-size: 14px;
        padding-left: 5px;
      }
    }
  }
  .translate-tips {
    position: absolute;
    top: 0;
    right: 90px;
    width: 186px;
    height: 180px;
    cursor: pointer;
    z-index: 2;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
</style>
